<template>
  <div id="fee_detail">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $route.query.id != undefined ? newsData.Status === ANN_STATUS.PENDING_ADJUSTMENT ? $t('News.Adjust') : $t('News.Modify') : $t('News.Create') }}公告
          </div>
        </div>
        <div class="right">
          <span class="tips">*為必填</span>
        </div>
      </div>
      <div class="blockWrap">
        <div v-if="originNewsData.Status === ANN_STATUS.PENDING_ADJUSTMENT" class="warning-container">
          <img
            src="@/assets/img/announcement/caution.svg"
            alt="caution"
            class="caution"
          />
          <span class="content">
            {{ $t('News.KeywordWarningMessage') }}
            <br>
            <br>
            {{ $t('News.KeywordWarningMessageRed') }}
          </span>
        </div>
        <el-form
          ref="newsData"
          class="list"
          :model="newsData"
          status-icon
          label-position="left"
          :rules="rule"
          :show-message="false"
        >
          <el-form-item
            label="標題"
            prop="Title"
          >
            <el-input
              v-model="newsData.Title"
              placeholder="請輸入標題"
              maxlength="100"
              size="medium"
            />
            <template><span>限100個字元</span></template>
          </el-form-item>
          <el-form-item
            label="公告類型"
            prop="Type"
          >
            <el-select
              v-model="newsData.Type"
              placeholder="請選擇"
              size="small"
            >
              <el-option
                v-for="item in TypeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              />
              <!-- <el-option v-if="!typeExist" v-for="item in NewsTypeList" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>  -->
            </el-select>
          </el-form-item>
          <el-form-item
            label="公告起日"
            prop="Start"
            class="Interval"
          >
            <el-date-picker
              v-model="newsData.Start"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              size="small"
              type="date"
              placeholder="選擇起日"
            />
          </el-form-item>
          <el-form-item
            label="公告訖日"
            prop="Due"
            class="Interval"
          >
            <el-date-picker
              v-model="newsData.Due"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              size="small"
              type="date"
              placeholder="選擇訖日(非必填)"
              :picker-options="datePickerOptions"
            />
          </el-form-item>
          <el-form-item
            label=""
            prop="Status"
          >
            <el-checkbox
              v-model="newsData.IsTop"
              :true-label="2"
              :false-label="0"
            >
              置頂
            </el-checkbox>
            <el-checkbox
              v-model="newsData.Status"
              :true-label="0"
              :false-label="1"
            >
              不公開
            </el-checkbox>
            <span class="description-label">{{ $t('News.PublishDescription') }}</span>
          </el-form-item>
          <el-form-item
            label="內容"
            prop="Detail"
          >
            <template>
              <textarea
                v-model="newsData.Detail"
                name="editor1"
              /><span>下方提供文字編輯，要加圖片可使用附加圖片功能。</span>
            </template>
          </el-form-item>
          <el-form-item
            label="附加檔案"
            prop="Files"
          >
            <template v-if="FileMaxNumber !=null">
              <file
                type="file"
                :filearray="newsData.Files"
                name="file"
                :quantity="FileMaxNumber"
                @on-fileArray-change="FilesChange"
              />
            </template>
          </el-form-item>
          <el-form-item
            label="附加圖片"
            prop="ImageFiles"
          >
            <template v-if="ImageMaxNumber !=null">
              <file
                v-model="newsData.ImageFiles"
                type="img"
                name="img"
                :filearray="newsData.ImageFiles"
                :quantity="ImageMaxNumber"
                @on-fileArray-change="ImageFilesChange"
              />
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.push({name:'news'})"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isDisable"
          round
          @click="SubNewsData"
        >
          送出
        </el-button>
      </div>
    </div>
    <!-- 訊息對話框 -->
    <NewsMessageDialog
      :visible.sync="isOpenNewsWarningDialog"
      :title="$t('News.KeywordWarningTitle')"
      :confirm-button-text="$t('News.KeywordWarningButton')"
      @confirm="isOpenNewsWarningDialog = false"
    />
  </div>
</template>
<script>
import file from '@/components/File'
import { processCKEditorData } from '@/js/utils/ckeditor.js'
import { apiAnnouncement } from '@/api/Announcement'
import { ANN_STATUS } from '@/js/utils/announcementStatus'
import NewsMessageDialog from './components/NewsMessageDialog.vue'

export default {
  components: {
    file,
    NewsMessageDialog
  },
  data () {
    const vm = this
    const validateTitle = (rule, value, callback) => {
      if (value.trim() === '') return callback(new Error('標題不能為空'))
      return callback()
    }
    return {
      ANN_STATUS,
      newsData: {
        Id: '',
        Title: '',
        Detail: '',
        Start: '',
        Due: '',
        Type: '',
        TypeName: '',
        Status: 1,
        IsTop: 0,
        Files: [],
        ImageFiles: []
      },
      originNewsData: {},
      FileMaxNumber: null,
      ImageMaxNumber: null,
      newsType: [],
      TypeList: [],
      NewsTypeList: [],
      typeExist: true,
      rule: {
        Title: [
          { required: true, message: '', trigger: 'blur' },
          { min: 0, max: 100, message: '', trigger: 'blur' },
          { validator: validateTitle, trigger: 'blur' }
        ],
        Type: [
          { required: true, message: '', trigger: 'blur' }
        ],
        Start: [
          { required: true, message: '', trigger: 'blur' }
        ]
      },
      ignoreWatch: {
        Start: false,
        Due: false,
        Status: false
      },
      isDisable: false,
      datePickerOptions: {
        disabledDate (time) {
          const today = vm.$formatDate(new Date())
          return time.getTime() < new Date(today).getTime()
        }
      },
      updateNotify: false,
      originNewsStatus: '',
      isOpenNewsWarningDialog: false
    }
  },
  watch: {
    'newsData.Start': {
      handler: function (val, old_val) {
        if (this.ignoreWatch.Start) {
          this.ignoreWatch.Start = false
          return false
        }
        if (Date.parse(this.newsData.Start).valueOf() > Date.parse(this.newsData.Due).valueOf()) {
          this.$alert('起日不可大於訖日!', '', {
            confirmButtonText: '確定',
            callback: action => {}
          })
          this.newsData.Start = old_val
        }
      }
    },
    'newsData.Due': {
      handler: function (val, old_val) {
        if (this.ignoreWatch.Due) {
          this.ignoreWatch.Due = false
          return false
        }
        if (Date.parse(this.newsData.Start).valueOf() > Date.parse(this.newsData.Due).valueOf()) {
          this.$alert('起日不可大於訖日!', '', {
            confirmButtonText: '確定',
            callback: action => {}
          })
          this.newsData.Due = old_val
        }
      }
    }
  },
  mounted () {
    this.UploadMaxNumber()
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.id != undefined) {
      this.ignoreWatch.Start = true
      this.ignoreWatch.Due = true
      this.ignoreWatch.Status = true
      this.GetNewsData().then(res => {
        this.originNewsData = JSON.parse(JSON.stringify(this.newsData))
        this.getTypeList().then(res => {
          if (!this.judgeTypeListExist()) {
            this.TypeList.push(this.NewsTypeList[0])
          }
        })
      })
      return false
    }
    this.getTypeList()
    this.SetCKEditor()
  },
  methods: {
    // 取得公告詳細
    GetNewsData () {
      const vobj = this
      const Authorization = this.$getCookie('comLoginToken').replace('token=', '')
      return new Promise((resolve, reject) => {
        axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Detail`, {
          method: 'GET',
          params: { announcementId: vobj.$route.query.id },
          headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache',
            Authorization
          }
        }).then(res => {
          const flag = res.data.Data
          console.log(flag)
          vobj.newsData = {
            Id: flag.Id,
            Title: flag.Title,
            Detail: flag.Detail,
            Start: flag.Start,
            Due: flag.Due,
            Type: flag.Type,
            TypeName: flag.TypeName,
            Status: flag.Status,
            IsTop: flag.IsTop,
            Files: [],
            ImageFiles: []
          }
          this.originNewsStatus = flag.Status
          console.log(vobj.newsData)
          this.NewsTypeList = []
          this.NewsTypeList.push({
            Id: flag.Type,
            Name: flag.TypeName,
            Value: flag.Type
          })
          console.log(this.NewsTypeList)
          flag.ImageFiles.forEach(val => {
            vobj.newsData.ImageFiles.push({
              type: 'img',
              file: '',
              uploadUrl: val.Url,
              expiringUrl: val.ExpiringUrl,
              BS64: ''
            })
          })
          flag.Files.forEach(val => {
            vobj.newsData.Files.push({
              type: 'file',
              file: '',
              uploadUrl: val.Url,
              expiringUrl: val.ExpiringUrl
            })
          })
          resolve(res)
          vobj.SetCKEditor()
        }).catch(err => {
          // callback(err.response);
        })
      })
    },
    UploadMaxNumber () {
      const vobj = this
      const Authorization = this.$getCookie('comLoginToken').replace('token=', '')

      axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/UploadMaxNumber`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          Authorization
        }
      }).then(res => {
        console.log(res)
        if (res.data.Status === 1) {
          vobj.FileMaxNumber = res.data.Data.FileMaxNumber
          vobj.ImageMaxNumber = res.data.Data.ImageMaxNumber
        } else {
          return Promise.reject(new Error('取得上傳檔案數量失敗'))
        }
      }).catch(err => {
        // callback(err.response);
      })
    },
    // 設定CKEditor
    SetCKEditor () {
      const vobj = this
      CKEDITOR.replace('editor1', {
        height: 200,
        language: 'zh'
      })
      CKEDITOR.instances.editor1.on('change', () => {
        const ckeditorData = CKEDITOR.instances.editor1.getData()
        vobj.newsData.Detail = ckeditorData
      })
    },
    // 檔案的components回釣函式
    FilesChange (val) {
      this.newsData.Files = val
    },
    // 檔案的components回釣函式
    ImageFilesChange (val) {
      this.newsData.ImageFiles = val
    },
    // 送出按鈕
    SubNewsData () {
      if (this.newsData.Title.trim() === '') {
        // eslint-disable-next-line eqeqeq
        this.$alert(`公告${this.$route.query.id == undefined ? '新增' : '更新'}失敗，標題不能為空`, '', {
          confirmButtonText: '確定',
          callback: action => { window.scrollTo(0, 0) }
        })
        return
      }
      this.isDisable = true
      this.$refs.newsData.validate((valid) => {
        if (!valid) {
          window.scrollTo(0, 0)
          return
        }

        // 新增或不公開情境不用跳確認視窗，直接上傳檔案
        if (this.$route.query.id === undefined || this.newsData.Status === ANN_STATUS.UNPUBLISHED) {
          this.FileUpload ()
          return
        }

        // 原始公告狀態為公告中 或 編輯後起日設定是在當日或之前，則顯示是否上架後通知的確認視窗
        if (this.originNewsStatus === ANN_STATUS.ANNOUNCING || (this.newsData.Start && !dayjs(this.newsData.Start).isAfter(dayjs(), 'day'))) {
          this.$confirm(this.$t('News.NewsBroadcastConfirmMsg'), this.$t('General.AlertTitle'), {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.updateNotify = true
            this.FileUpload()
          }).catch(() => {
            this.FileUpload()
          })
        } else {
          this.FileUpload()
        }
      })
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
    },
    // 上傳檔案&紀錄
    FileUpload () {
      const vobj = this
      const totalCount = { img: vobj.newsData.ImageFiles.length, file: vobj.newsData.Files.length }
      const uploadStatus = { img: { success: 0, error: 0 }, file: { success: 0, error: 0 } }
      const loadingWrap = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // eslint-disable-next-line eqeqeq
      if (totalCount.img + totalCount.file == 0) {
        document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後'
      } else {
        document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
      }

      upload_image()
      // 上傳圖片
      function upload_image () {
        // eslint-disable-next-line eqeqeq
        if (vobj.newsData.ImageFiles.length != 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
          const now_index = uploadStatus.img.success + uploadStatus.img.error
          // eslint-disable-next-line eqeqeq
          if (vobj.newsData.ImageFiles[now_index].file == '') {
            uploadStatus.img.success += 1
            next()
          } else {
            SandUpdateFileApi(vobj.newsData.ImageFiles[now_index].file, res => {
              if (res !== 'error') {
                vobj.newsData.ImageFiles[now_index].uploadUrl = res.data.Data.FileUrl
                uploadStatus.img.success += 1
                next()
              }
            })
          }
          function next () {
            // Progress_add += 100 / (totalCount.img+totalCount.file)
            // vobj.Progress.setProgress(Progress_add)
            // eslint-disable-next-line eqeqeq
            if (totalCount.img == uploadStatus.img.success + uploadStatus.img.error) {
              upload_file()
            } else {
              upload_image()
            }
          }
        } else {
          upload_file()
        }
      }
      // 上傳檔案
      function upload_file () {
        // eslint-disable-next-line eqeqeq
        if (vobj.newsData.Files.length != 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
          const now_index = uploadStatus.file.success + uploadStatus.file.error

          // eslint-disable-next-line eqeqeq
          if (vobj.newsData.Files[now_index].file == '') {
            uploadStatus.file.success += 1
            next()
          } else {
            SandUpdateFileApi(vobj.newsData.Files[now_index].file, res => {
              if (res !== 'error') {
                vobj.newsData.Files[now_index].uploadUrl = res.data.Data.FileUrl
                uploadStatus.file.success += 1
                next()
              }
            })
          }

          function next () {
            document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.img.success + uploadStatus.img.error + uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
            // eslint-disable-next-line eqeqeq
            if (totalCount.file == uploadStatus.file.success + uploadStatus.file.error) {
              document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後...'
              sand_api()
            } else {
              upload_file()
            }
          }
        } else {
          sand_api()
        }
      }
      // 新增 / 編輯公告
      function sand_api () {
        const Authorization = vobj.$getCookie('comLoginToken').replace('token=', '')
        // eslint-disable-next-line eqeqeq
        const url = vobj.$route.query.id == undefined ? `${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Create` : `${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Edit`
        const Data = {
          Title: vobj.newsData.Title,
          Detail: processCKEditorData(vobj.newsData.Detail),
          Start: vobj.newsData.Start,
          Due: vobj.newsData.Due,
          Type: vobj.newsData.Type,
          Status: vobj.newsData.Status !== 0 ? 1 : 0, // 1 視為 "要上架"，0 視為 "不顯示" 的草稿狀態,
          IsTop: vobj.newsData.IsTop ? '2' : '0',
          Files: [],
          ImageFiles: [],
          NotifyAfterReviewPassed: vobj.updateNotify ? '1' : '0'
        }
        // eslint-disable-next-line eqeqeq
        if (vobj.$route.query.id != undefined) {
          Data.Id = vobj.newsData.Id
        }

        vobj.newsData.Files.forEach(val => {
          Data.Files.push({ FileName: val.uploadUrl.split('/')[val.uploadUrl.split('/').length - 1], Url: val.uploadUrl })
        })
        vobj.newsData.ImageFiles.forEach(val => {
          Data.ImageFiles.push({ FileName: val.uploadUrl.split('/')[val.uploadUrl.split('/').length - 1], Url: val.uploadUrl })
        })
        console.log(Data)
        axios(url, {
          // eslint-disable-next-line eqeqeq
          method: vobj.$route.query.id == undefined ? 'POST' : 'PUT',
          data: Data,
          headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache',
            Authorization
          }
        }).then(res => {
          loadingWrap.close()
          vobj.$store.commit('ifNewsEdit', true)
          const isPublish = Data.Status === 1
          const isInsert = vobj.$route.query.id === undefined
          const msg = isPublish ? vobj.$t('News.NewsInProgress') : isInsert ? vobj.$t('News.InsertNewsSuccess') : vobj.$t('News.UpdateNewsSuccess')
          sessionStorage.setItem('news_flash_message', msg)
          vobj.$router.push({ name: 'news' })
        }).catch(err => {
          loadingWrap.close()
          if (err.response?.data.ErrorMessage.Code === 400020) {
            vobj.isOpenNewsWarningDialog = true
          } else {
            vobj.$alert(`公告${vobj.$route.query.id === undefined ? '新增' : '更新'}失敗，${err.response?.data.ErrorMessage.Description}`, '', {
              confirmButtonText: '確定',
              callback: action => {
              }
            })
          }
        })
      }
      // 處理檔案上傳API
      function SandUpdateFileApi (FileData, callback) {
        const uploadFormData = new FormData()
        uploadFormData.append('file', FileData)
        apiAnnouncement.updateFile(uploadFormData).then((res) => {
          callback(res)
        }).catch(err => {
          loadingWrap.close()
          vobj.$message({
            message: '上傳過程發生異常，請重新再[送出]一次',
            type: 'warning'
          })
          callback('error')
        })
      }
    },
    // 取得公告類型列表
    getTypeList () {
      const Authorization = 'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      this.modalLoading = true
      return new Promise((resolve, reject) => {
        axios(`${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementList`, {
          method: 'GET',
          // params: data,
          headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache',
            KingnetAuth: Authorization
          }
        }).then(res => {
          this.modalLoading = false
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) {
            this.TypeList = res.data.Data.List
            resolve(res.data.Data.List)
          } else {
            reject(new Error('取得公告類別失敗'))
          }
        }).catch(err => {
          console.log(err.response)
        })
      })
    },
    judgeTypeListExist () {
      let output = false
      for (const item of this.TypeList) {
        // eslint-disable-next-line eqeqeq
        if (this.newsData.Type == item.Id) {
          return true
        } else {
          output = false
        }
      }
      return output
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_detail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tips
        color: #f00
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    +basicFormInsert
    .el-form-item
      &.Interval
        width: 50%
        padding: 5px
      &.half
        width: 50%
      &__content
        flex: 1
        // max-width: 400px
        .file-wrap
          flex-wrap: wrap
        .el-select,.el-date-editor
          width: 100%
    .description-label
      font-size: map-get($fontSize,small)
      color: $subFontColor
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 240px 0 240px
    box-sizing: border-box
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
.warning-container
  flex-grow: 0
  display: flex
  flex-direction: row
  justify-content: flex-start
  margin-bottom: 32px
  gap: 10px
  padding: 16px
  border-radius: 8px
  background-color: #ffefdd
  .content
    font-size: map-get($fontSize, small)
    font-weight: 600
    line-height: 1.4
    text-align: left
    color: #fd773d
  .caution
    width: 20px
    height: 20px

</style>
